import { Check, X } from 'lucide-react';

interface PasswordGuideProps {
  password_confirmation: string;
}

export default function PasswordGuide({ password_confirmation }: PasswordGuideProps) {
  const hasLowerCase = /[a-z]/.test(password_confirmation);
  const hasUpperCase = /[A-Z]/.test(password_confirmation);
  const hasNumber = /\d/.test(password_confirmation);
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password_confirmation);
  const isLongEnough = password_confirmation.length >= 8;

  const requirements = [
    { label: 'At least 8 characters', met: isLongEnough },
    { label: 'At least one lowercase letter (a-z)', met: hasLowerCase },
    { label: 'At least one uppercase letter (A-Z)', met: hasUpperCase },
    { label: 'At least one number (0-9)', met: hasNumber },
    { label: 'At least one special character', met: hasSpecialChar },
  ];

  return (
    <div className="mt-4 space-y-2">
      <p className="text-xs md:text-sm font-semibold text-slate-700">Password must contain:</p>
      <ul className="space-y-1">
        {requirements.map((req, index) => (
          <li key={index} className={`flex items-center text-xs md:text-sm ${req.met ? 'text-green-600' : 'text-slate-500'}`}>
            {req.met ? <Check size={16} className="mr-2" /> : <X size={16} className="mr-2" />}
            {req.label}
          </li>
        ))}
      </ul>
    </div>
  );
}